"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stellarService_1 = require("./stellarService");
const axios_1 = __importDefault(require("axios"));
const stellar_sdk_1 = require("stellar-sdk");
exports.selfFundTrustLine = (keyPair, asset_code) => __awaiter(void 0, void 0, void 0, function* () {
    const { server, currencies, network } = stellarService_1.getConfig();
    const fee = String(yield server.fetchBaseFee());
    const transactionAccount = yield server.loadAccount(keyPair.publicKey());
    const transaction = new stellar_sdk_1.TransactionBuilder(transactionAccount, {
        fee,
        networkPassphrase: network,
    });
    const asset = new stellar_sdk_1.Asset(currencies[asset_code].asset_code, currencies[asset_code].issuer);
    transaction.addOperation(stellar_sdk_1.Operation.changeTrust({
        asset: asset,
    }));
    transaction.setTimeout(3000);
    const tx = transaction.build();
    tx.sign(keyPair);
    yield server.submitTransaction(tx);
});
exports.fundTrustLine = (keyPair, asset_code) => __awaiter(void 0, void 0, void 0, function* () {
    const { serviceUrl, network, server, currencies } = stellarService_1.getConfig();
    const response = yield axios_1.default.post(`${serviceUrl}/activation_service/fund_trustline`, {
        asset: `${currencies[asset_code].asset_code}:${currencies[asset_code].issuer}`,
        address: keyPair.publicKey(),
    });
    const tx = new stellar_sdk_1.Transaction(response.data.addtrustline_transaction, network);
    tx.sign(keyPair);
    yield server.submitTransaction(tx);
});
//# sourceMappingURL=trustlineService.js.map